import { KeyboardEvent } from 'react';
import { ControllerStateAndHelpers } from 'downshift';
import {
	IDropdownItem,
	DropdownList,
	IGetItemDisplayValue,
	IGetItemKey,
} from '../DropdownList';
import { AutoSuggestMain } from './AutoSuggestMain';

interface IAutoSuggestRootProps
	extends ControllerStateAndHelpers<IDropdownItem> {
	placeholder?: string;
	ariaLabel?: string;
	getItemDisplayValue: IGetItemDisplayValue;
	getItemKey: IGetItemKey;
	items: IDropdownItem[];
	innerRef: () => void;
	onKeyUp?: (event: KeyboardEvent<HTMLInputElement>) => void;
	disabled?: boolean;
	invalid?: boolean;
	required?: boolean;
	placeholderAsLabel?: boolean;
	onClearSearch?: () => void;
}

export function AutoSuggestRoot({
	highlightedIndex,
	getMenuProps,
	getItemProps,
	getInputProps,
	selectedItem,
	clearSelection,
	getItemDisplayValue,
	getItemKey,
	innerRef,
	isOpen,
	placeholder,
	ariaLabel,
	items,
	onKeyUp,
	disabled,
	invalid,
	required,
	placeholderAsLabel,
	onClearSearch,
}: IAutoSuggestRootProps) {
	return (
		<div ref={innerRef}>
			<AutoSuggestMain
				getInputProps={getInputProps}
				isOpen={isOpen}
				placeholder={placeholder}
				ariaLabel={ariaLabel}
				clearSelection={clearSelection}
				onKeyUp={onKeyUp}
				disabled={disabled}
				invalid={invalid}
				required={required}
				placeholderAsLabel={placeholderAsLabel}
				onClearSearch={onClearSearch}
			/>

			<DropdownList
				getItemDisplayValue={getItemDisplayValue}
				highlightedIndex={highlightedIndex}
				getMenuProps={getMenuProps}
				selectedItem={selectedItem}
				getItemProps={getItemProps}
				getItemKey={getItemKey}
				isOpen={isOpen}
				items={items}
			/>
		</div>
	);
}
